<template>
  <v-dialog v-model="dialog" width="1000px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">{{ tituloDinamico }}</span>
      </v-card-title>
      <v-card-text v-html="htmlAtual" class="pt-3" style="max-height: 60vh; overflow-y: auto;">
      </v-card-text>

      <v-card-actions>
        <v-radio-group v-model="aceites[stepIndex]" row :key="stepIndex">
          <v-radio
            :label="`${$tc('label.li_concordo_termos_condicoes')}`"
            :value="true"
          ></v-radio>
        </v-radio-group>

        <v-spacer></v-spacer>
        <v-btn text @click.native="close">
          {{ $t('label.fechar') }}
        </v-btn>

        <v-btn
          v-if="stepIndex > 0"
          text
          dark
          color="accent"
          @click="passoAnterior"
        >
          {{ $t('label.anterior') }}
        </v-btn>

        <v-btn
          v-if="stepIndex < gruposParaAceite.length - 1"
          color="primary"
          :disabled="!aceites[stepIndex]"
          @click="proximoPasso"
        >
          {{ $tc('label.proximo', 1) }}
        </v-btn>

        <v-btn
          v-if="stepIndex === gruposParaAceite.length - 1"
          id="finalizar"
          color="primary"
          dark
          :disabled="!todosAceitos"
          @click.native="finalizar"
        >
          {{ $t('label.finalizar') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UsuarioFormTermoAceiteDialog',
  props: {
    termoAceite: Object,
  },
  data() {
    return {
      dialog: false,
      stepIndex: 0,
      gruposParaAceite: [],
      aceites: [],
      dadosUsuario: {},
    };
  },
  computed: {
    tituloDinamico() {
      if (this.gruposParaAceite.length === 0) return this.$tc('label.termo_aceite');

      const grupoAtual = this.gruposParaAceite[this.stepIndex];
      const nomeGrupo = grupoAtual.nomExtensao || grupoAtual.nome || '';

      return this.$t('title.termo_aceite_quantidade_grupo_fornecedor', { qtdInicial: this.stepIndex + 1, qtdFinal: this.gruposParaAceite.length, nomeGrupo });
    },
    htmlAtual() {
      if (this.gruposParaAceite.length === 0 || !this.termoAceite.conteudo) return '';

      const grupoAtual = this.gruposParaAceite[this.stepIndex];
      const nomeBruto = grupoAtual.nomExtensao || grupoAtual.nome || '';
      const razaoSocialLimpa = nomeBruto.includes(' - ') ? nomeBruto.split(' - ')[1] : nomeBruto;

      let htmlRazaoSocialCnpj = '';
      let textoCnpjs = '';

      if (Array.isArray(grupoAtual.cnpjs) && grupoAtual.cnpjs.length > 0) {
        htmlRazaoSocialCnpj = grupoAtual.cnpjs.map((item) => {
          const parteNumero = item.nome_cnpj ? item.nome_cnpj.split(' - ')[0] : '';
          const cnpjLimpo = parteNumero.replace(/[^a-zA-Z0-9]/g, '');
          return `<p style="margin:0;">${razaoSocialLimpa}, inscrita no CNPJ sob nº ${cnpjLimpo}</p>`;
        }).join('');

        textoCnpjs = grupoAtual.cnpjs.map((item) => {
          const parteNumero = item.nome_cnpj ? item.nome_cnpj.split(' - ')[0] : '';
          return parteNumero.replace(/[^a-zA-Z0-9]/g, '');
        }).join(', ');
      } else {
        htmlRazaoSocialCnpj = `<p style="margin:0;">${razaoSocialLimpa}</p>`;
      }
      return this.substituirValores(
        this.termoAceite.conteudo,
        this.dadosUsuario.email,
        razaoSocialLimpa,
        htmlRazaoSocialCnpj,
        textoCnpjs,
        this.dadosUsuario.nomeUsuarioCriado,
      );
    },
    todosAceitos() {
      return this.aceites.length === this.gruposParaAceite.length && this.aceites.every((v) => v === true);
    },
  },
  methods: {
    open(email, razaoSocialDefault, nomeUsuarioCriado, listaGrupos) {
      this.dadosUsuario = { email, nomeUsuarioCriado, razaoSocialDefault };

      if (!listaGrupos || listaGrupos.length === 0) {
        this.gruposParaAceite = [{ nome: '', razaoSocial: razaoSocialDefault }];
      } else {
        this.gruposParaAceite = listaGrupos;
      }

      this.stepIndex = 0;
      this.aceites = new Array(this.gruposParaAceite.length).fill(false);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    passoAnterior() {
      if (this.stepIndex > 0) {
        this.stepIndex -= 1;
      }
    },

    proximoPasso() {
      if (this.aceites[this.stepIndex] && this.stepIndex < this.gruposParaAceite.length - 1) {
        this.stepIndex += 1;
      }
    },
    substituirValores(html, email, razaoSocial, htmlRazaoSocialCnpj, textoCnpjs, nomeUsuarioCriado) {
      let conteudo = html;
      const valores = {
        '[RAZAO_SOCIAL_CNPJ]': htmlRazaoSocialCnpj,
        '[CNPJ]': textoCnpjs,
        '[RAZAO_SOCIAL]': razaoSocial,
        '[GRUPO_FORNECEDOR]': razaoSocial,
        '[NOME_COMPLETO_USUARIO_CRIADO]': nomeUsuarioCriado,
        '[EMAIL]': email,
      };

      Object.entries(valores).forEach(([chave, valor]) => {
        const regex = new RegExp(chave.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1'), 'g');
        conteudo = conteudo.replace(regex, valor || '');
      });

      return conteudo;
    },
    finalizar() {
      if (!this.todosAceitos) {
        this.$toast(this.$t('message.erro_todos_termos_devem_ser_aceitos'));
        return;
      }

      const listaDeAceites = this.gruposParaAceite.map((grupo) => ({
        idGrupoFornecedor: grupo.id,
        indAceito: true,
      }));

      this.dialog = false;
      this.$emit('Finalizar', listaDeAceites);
    },
  },
};
</script>
